<mat-card *ngIf="dades" style="float:left;clear: both;background-color:transparent;border-width: 0px;width:100%;padding:0px;padding-top:20px">
<mat-card-content style='float:left;clear:left;width:100%;padding:0px;border-width: 0px'>
<div style='float:left;clear:left;width:450px;border-bottom: 1px solid #eee;border-width: 0px'>
<div style='float:left;clear:left;width:100%;font-weight: normal;text-transform: uppercase'>
  <div style='float:left;clear:none;width:45%'>{{ 'resumTreballs.titolAmbit' | translate }}</div>
  <div style='float:left;clear:none;width:15%;text-align: right'>{{ 'resumTreballs.colNombre' | translate }}</div>
  <div style='float:left;clear:none;width:35%;text-align: right;'>{{ 'resumTreballs.colImport' | translate }}</div>
</div>
<div style='float:left;clear:left;width:100%'>
  <div style='float:left;clear:none;width:45%;color:rgb(100,100,100)'>{{ 'resumTreballs.catalunya' | translate }}</div>
  <div style='float:left;clear:none;width:15%;text-align:right'>{{dades.ambit.numCAT | number:'1.0-0' }}</div>
  <div *ngIf="dades.ambit.totalCAT != 0" style='float:left;clear:none;width:35%;text-align:right'>{{dades.ambit.totalCAT | number:'1.0-0' }}</div>
  <div *ngIf="dades.ambit.totalCAT == 0" style='float:left;clear:none;width:35%;text-align:right'>-</div>
</div>
<div style='float:left;clear:left;width:100%'>
  <div style='float:left;clear:none;width:45%;color:#0000FF'>{{ 'resumTreballs.europa' | translate }}</div>
  <div style='float:left;clear:none;width:15%;text-align:right'>{{dades.ambit.numEU | number:'1.0-0' }}</div>
  <div *ngIf="dades.ambit.totalEU != 0" style='float:left;clear:none;width:35%;text-align:right'>{{dades.ambit.totalEU | number:'1.0-0' }}</div>
  <div *ngIf="dades.ambit.totalEU == 0" style='float:left;clear:none;width:35%;text-align:right'>-</div>
</div>
<div style='float:left;clear:left;width:100%'>
  <div style='float:left;clear:none;width:45%;color:#009900'>{{ 'resumTreballs.internacional' | translate }}</div>
  <div style='float:left;clear:none;width:15%;text-align:right'>{{dades.ambit.numInt | number:'1.0-0' }}</div>
  <div *ngIf="dades.ambit.totalInt != 0" style='float:left;clear:none;width:35%;text-align:right'>{{dades.ambit.totalInt | number:'1.0-0' }}</div>
  <div *ngIf="dades.ambit.totalInt == 0" style='float:left;clear:none;width:35%;text-align:right'>-</div>
</div>
<div style='float:left;clear:left;width:100%'>
  <div style='float:left;clear:none;width:45%;color:#800000'>{{ 'resumTreballs.espanya' | translate }}</div>
  <div style='float:left;clear:none;width:15%;text-align:right'>{{dades.ambit.numE | number:'1.0-0' }}</div>
  <div *ngIf="dades.ambit.totalE != 0" style='float:left;clear:none;width:35%;text-align:right'>{{dades.ambit.totalE | number:'1.0-0' }}</div>
  <div *ngIf="dades.ambit.totalE == 0" style='float:left;clear:none;width:35%;text-align:right'>-</div>
</div>
</div>
<div style='float:left;clear:left;width:450px;padding-top:20px'>
<div style='float:left;clear:left;width:100%'>
  <div style='float:left;clear:none;width:45%'>{{ 'resumTreballs.titolEmpresa' | translate }}</div>
  <div style='float:left;clear:none;width:15%;text-align: right'>{{ 'resumTreballs.colNombre' | translate }}</div>
  <div style='float:left;clear:none;width:35%;text-align: right;'>{{ 'resumTreballs.colImport' | translate }}</div>
</div>
<div style='float:left;clear:left;width:100%'>
  <div style='float:left;clear:none;width:45%'>MCRIT</div>
  <div style='float:left;clear:none;width:15%;text-align:right'>{{dades.empresa.numMCRIT | number:'1.0-0' }}</div>
  <div *ngIf="dades.empresa.totalMCRIT != 0" style='float:left;clear:none;width:35%;text-align:right'>{{dades.empresa.totalMCRIT | number:'1.0-0' }}</div>
  <div *ngIf="dades.empresa.totalMCRIT == 0" style='float:left;clear:none;width:35%;text-align:right'>-</div>
</div>
<div style='float:left;clear:left;width:100%'>
  <div style='float:left;clear:none;width:45%'>MULTICRITERIA</div>
  <div style='float:left;clear:none;width:15%;text-align:right'>{{dades.empresa.numMULTI | number:'1.0-0' }}</div>
  <div *ngIf="dades.empresa.totalMULTI != 0" style='float:left;clear:none;width:35%;text-align:right'>{{dades.empresa.totalMULTI | number:'1.0-0' }}</div>
  <div *ngIf="dades.empresa.totalMULTI == 0" style='float:left;clear:none;width:35%;text-align:right'>-</div>
</div>
<div style='float:left;clear:left;width:100%'>
  <div style='float:left;clear:none;width:45%'>Multicriteri MCRIT AIE</div>
  <div style='float:left;clear:none;width:15%;text-align:right'>{{dades.empresa.numAIEMULTI | number:'1.0-0' }}</div>
  <div *ngIf="dades.empresa.totalAIEMULTI != 0" style='float:left;clear:none;width:35%;text-align:right'>{{dades.empresa.totalAIEMULTI | number:'1.0-0' }}</div>
  <div *ngIf="dades.empresa.totalAIEMULTI == 0" style='float:left;clear:none;width:35%;text-align:right'>-</div>
</div>
<div style='float:left;clear:left;width:100%'>
  <div style='float:left;clear:none;width:45%'>Geovincles</div>
  <div style='float:left;clear:none;width:15%;text-align:right'>{{dades.empresa.numGEO | number:'1.0-0' }}</div>
  <div *ngIf="dades.empresa.totalGEO != 0" style='float:left;clear:none;width:35%;text-align:right'>{{dades.empresa.totalGEO | number:'1.0-0' }}</div>
  <div *ngIf="dades.empresa.totalGEO == 0" style='float:left;clear:none;width:35%;text-align:right'>-</div>
</div>
<div style='float:left;clear:left;width:100%'>
  <div style='float:left;clear:none;width:45%'>Ersília</div>
  <div style='float:left;clear:none;width:15%;text-align:right'>{{dades.empresa.numERSI | number:'1.0-0' }}</div>
  <div *ngIf="dades.empresa.totalERSI != 0" style='float:left;clear:none;width:35%;text-align:right'>{{dades.empresa.totalERSI | number:'1.0-0' }}</div>
  <div *ngIf="dades.empresa.totalERSI == 0" style='float:left;clear:none;width:35%;text-align:right'>-</div>
</div>
</div>
</mat-card-content>
</mat-card>
